var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "background",
      style: { backgroundImage: "url(" + _vm.backgroundProp.thumbnail + ")" }
    },
    [
      _c("img", {
        staticClass: "image",
        attrs: { src: _vm.overlayProp, alt: "" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }